import React from 'react';
import ReportingFinancesPage from '../components/ReportingFinancesPage';

const ReportingFinancesApp = (props) => (
  <ReportingFinancesPage {...props} />
);

export default ReportingFinancesApp;
